const downloadStarts = (event, customText) => {
  window.sendDownloadData(event, null, customText);
};

export default downloadStarts;
